import { render } from "./GarmentSilhouette.vue?vue&type=template&id=55bbeff2&scoped=true"
import script from "./GarmentSilhouette.vue?vue&type=script&lang=js"
export * from "./GarmentSilhouette.vue?vue&type=script&lang=js"

import "./GarmentSilhouette.vue?vue&type=style&index=0&id=55bbeff2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55bbeff2"]])

export default __exports__